/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { Node } from '../../core/models/Node';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';
import { IVisitor } from '../../core/visitors/IVisitor';
import { Document } from '../../core/models/Document';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends OAuthFlows
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiOAuthFlows extends OAuthFlows {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let v : IAaiVisitor = <IAaiVisitor><any>visitor;
        v.visitOAuthFlows(this);
    }
}
AaiOAuthFlows["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiOAuthFlows";
AaiOAuthFlows["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




